import React, { Component } from 'react';
import * as mat from 'material-ui'
import { FormErrors, ConfirmPass } from './formErrors';
import './style.css'
// import FaGoogle from 'react-icons/lib/fa/google';
import gLogo from '../images/G__Logo.png';
import fLogo from '../images/facebook-icon.png'
import { loginWithGoogle, loginWithFacebook, UserLogInAction ,sendForgotPasswordEmail } from '../../action/authAction'
import * as firebase from 'firebase';
import { browserHistory } from 'react-router';


import { connect } from 'react-redux'

class LOGIN extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            emailChage: '',
            formErrors: { email: '', password: '' },
            confirmPass: { emailChage: '' },
            emailValid: false,
            passwordValid: false,
            emailChageValid: false,
            passwordChangeValid: false,
            formValid: false,
            changePass: false,
            open: false,

        }
    }
    componentWillMount() {
        if (this.props.auth) {
            browserHistory.push('/')
        }
    }

    ForgetHandle = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value },
            () => { this.validateChagePass(name, value) });
    }

    validateChagePass(fieldName, value) {
        let fieldValidationErrors = this.state.confirmPass;
        let emailChageValid = this.state.emailChageValid;


        switch (fieldName) {
            case 'emailChage':
                emailChageValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                fieldValidationErrors.Email = emailChageValid ? '' : ' is invalid (example@gmail.com)';
                break;
            default:
                break;
        }
        this.setState({
            confirmPass: fieldValidationErrors,
            emailChageValid: emailChageValid,
        }, this.validateFormNewPass);
    }
    validateFormNewPass() {
        this.setState({ changePass: this.state.emailChageValid });
    }
    SubmitChagnePassword() {
        let emailChage = this.state.emailChage;
        let ForgetPasswords = {
            email: emailChage,
        }
        // console.log('User Login', ForgetPasswords);
        this.props.sendForgotPasswordEmail(ForgetPasswords);
    }

    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value },
            () => { this.validateField(name, value) });
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let emailValid = this.state.emailValid;
        let passwordValid = this.state.passwordValid;


        switch (fieldName) {
            case 'email':
                emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                fieldValidationErrors.Email = emailValid ? '' : ' is invalid (example@gmail.com)';
                break;
            case 'password':
                passwordValid = value.length >= 6;
                fieldValidationErrors.Password = passwordValid ? '' : ' is too short';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            emailValid: emailValid,
            passwordValid: passwordValid
        }, this.validateForm);
    }

    validateForm() {
        this.setState({ formValid: this.state.emailValid && this.state.passwordValid });
    }
    Login() {
        let email = this.state.email;
        let password = this.state.password;

        let LogInUser = {
            email: email,
            password: password
        }
        // console.log('User Login', LogInUser);
        this.props.UserLogInAction(LogInUser);
    }
    LoginWithGmail() {
        let providers = new firebase.auth.GoogleAuthProvider();
        this.props.loginWithGoogle(providers)
    }
    LoginWithFacebook() {
        let provider = new firebase.auth.FacebookAuthProvider();
        this.props.loginWithFacebook(provider)
    }
    errorClass(error) {
        return (error.length === 0 ? '' : 'has-error');
    }
    Forget = () => {
        // alert("Under Working")
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    render() {
        const actions = [
            <mat.FlatButton
                label="Cancel"
                primary={true}
                onClick={this.handleClose}
            />,
            <mat.FlatButton
                label="Send"
                primary={true}
                disabled={!this.state.changePass}
                keyboardFocused={true}
                onClick={this.SubmitChagnePassword.bind(this)}
            />,
        ];
        const {
            GLoader,
            Error,
            fbLoader,
            sent,
            Loader
        } = this.props;
        return (
            <div>
                <div>
                    <mat.Card
                        zDepth={0}
                        className='col-md-4 col-md-offset-4 col-xs-10 col-xs-offset-1 login'
                    >
                        {/* Login Header */}
                        <mat.AppBar
                            title='LOGIN'
                            titleStyle={{ textShadow: '0px 2px 3px gray', fontSize: '3em', fontWeight: 'bold', color: '#41c4dd' }}
                            className='text-center'
                            showMenuIconButton={false}
                            style={{ backgroundColor: 'white' }}
                            zDepth={0}
                        />
                        <mat.CardText style={{ marginTop: '5%' }}>
                            <div >
                                {(GLoader === false) ? (
                                    <button
                                        onClick={this.LoginWithGmail.bind(this)}
                                        style={{ fontSize: 20, width: '100%', textAlign: 'left' }}
                                        className=" btn btn-default"
                                    >
                                        <img src={gLogo} style={{ width: 30 }} alt='glogo' /> Login with Google
                                </button>

                                ) : (
                                        <div className='text-Center'>
                                            <mat.LinearProgress mode="indeterminate" color='#1e5a89' />
                                        </div>
                                    )}

                            </div>
                            <br />
                            <div>
                                {(fbLoader === false) ? (
                                    <button
                                        onClick={this.LoginWithFacebook.bind(this)}
                                        // disabled={!this.state.formValid}
                                        style={{ fontSize: 20, width: '100%', textAlign: 'left' }}
                                        className=" btn btn-default"
                                    >
                                        <img src={fLogo} style={{ width: 30 }} alt='flogo' /> Login with Facebook
                                </button>
                                ) : (
                                        <div className='text-Center'>
                                            <mat.LinearProgress mode="indeterminate" color='#1e5a89' />
                                        </div>
                                    )}
                            </div>
                            <br />
                            <div className="input-group input-group-lg">
                                <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                                <input
                                    name="email"
                                    className="form-control"
                                    placeholder="Email"
                                    aria-label="Email"
                                    required
                                    aria-describedby="sizing-addon1"
                                    value={this.state.email}
                                    onChange={this.handleUserInput}
                                />
                            </div>
                            <br />
                            <div className="input-group input-group-lg">
                                <span className="input-group-addon"><i className="glyphicon glyphicon-lock"></i></span>
                                <input
                                    name="password"
                                    className="form-control"
                                    placeholder="Password"
                                    aria-label="Password"
                                    required
                                    type="password"
                                    aria-describedby="sizing-addon1"
                                    value={this.state.password}
                                    onChange={this.handleUserInput}
                                />
                            </div>
                            <br />
                            <div className='text-center' style={{ fontSize: 16, color: 'red' }}>
                                <FormErrors formErrors={this.state.formErrors} />
                            </div>
                            <div>
                                {(Error) ? (
                                    <div style={{ fontSize: 16, color: 'red', textAlign: 'center' }}>
                                        {Error}
                                    </div>
                                ) : (
                                        <span></span>
                                    )}
                            </div>
                            <div>
                                {(Loader === false) ? (
                                    <button
                                        onClick={this.Login.bind(this)}
                                        className="btn btn-info btn-group-justified"
                                        disabled={!this.state.formValid}
                                        style={{ fontSize: 20 }}
                                    >
                                        Sign In
                                </button>
                                ) : (
                                        <div className='text-Center'>
                                            <mat.LinearProgress mode="indeterminate" color='#1e5a89' />
                                        </div>
                                    )}

                            </div>
                            <br />
                            <div className="text-center">
                                <a onClick={this.Forget.bind(this)} style={{ fontSize: 18, cursor: 'pointer' }} data-toggle="popover" title="Popover Header" data-content="Some content inside the popover">Lost your password ?</a>
                            </div>
                        </mat.CardText>
                    </mat.Card>
                </div>
                <div>
                    <mat.Dialog
                        title="Create New Password"
                        actions={actions}
                        modal={false}
                        open={this.state.open}
                        onRequestClose={this.handleClose}
                    >
                        <div className="form-group">
                            <label htmlFor="email">Enter your email, You have.</label>
                            <input
                                name="emailChage"
                                className="form-control"
                                placeholder="Enter email"
                                required
                                value={this.state.emailChage}
                                onChange={this.ForgetHandle}
                            />
                        </div>
                        <div style={{ marginTop: 10, fontSize: 16, color: 'red' }}>
                            <ConfirmPass confirmPass={this.state.confirmPass} />
                        </div>
                        <div>
                            {(sent) ? (
                                <div style={{ marginTop: 10, fontSize: 16, color: 'blue', textAlign: 'center' }}>
                                    {sent}
                                </div>
                            ) : (
                                    <span></span>
                                )}
                        </div>
                    </mat.Dialog>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        GLoader: state.authReducers.Googleloader,
        fbLoader: state.authReducers.Fbloader,
        Loader: state.authReducers.LoaderLogin,
        Error: state.authReducers.error,
        sent: state.authReducers.sentEmail
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        loginWithGoogle: (providers) => {
            dispatch(loginWithGoogle(providers));
        },
        loginWithFacebook: (provider) => {
            dispatch(loginWithFacebook(provider));
        },
        UserLogInAction: (action) => {
            dispatch(UserLogInAction(action))
        },
        sendForgotPasswordEmail: (action) => {
            dispatch(sendForgotPasswordEmail(action))
        }
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(LOGIN);
// export default LOGIN


// WEBPACK FOOTER //
// ./src/component/auth/login.jsx